const DEFAULT_CHECK_INTERVAL = 500

export function waitForClose(
    popup: Window,
    signal: AbortSignal,
    checkInterval = DEFAULT_CHECK_INTERVAL
): Promise<null> {
    return new Promise((resolve) => {
        const intervalId = setInterval(() => {
            if (popup.closed) {
                resolve(null)
            }
        }, checkInterval)

        signal.addEventListener('abort', () => clearInterval(intervalId))
    })
}
